import styled from "styled-components";
import { theme } from "../theme";

export const StyledDecisionPreview = styled.div`
	padding-bottom: 25px;

	& .divider {
		width: 100%;
		height: 0.1rem;
		margin: 1.2rem 0;

		display: block;

		border-top: 1px solid #e5e9ec;
	}

	& .icon {
		width: 4.4rem;
		height: 4.4rem;

		display: flex;
		align-items: center;
		justify-content: center;

		position: absolute;
		top: 0;
		left: 0;

		background-color: ${(props) => (props.color ? props.color : "cyan")};
		border-radius: 100rem;

		& > span {
			color: #ffffff;
			height: 1.7rem;
			width: min-content;

			color: #ffffff;
			text-transform: uppercase;
			font-family: ${theme.font.secondary};
			font-size: 2rem;
			font-weight: 500;

			display: block;
		}
	}

	& .description-container {
		display: flex;
		flex-direction: column;

		row-gap: 1.2rem;

		& span {
			color: ${theme.color.gray};
			font-size: 0.8rem;
			font-weight: 500;
			text-transform: uppercase;
			font-family: ${theme.font.secondary};
		}

		& p {
			font-size: 1.2rem;
			font-weight: 300;
		}

		& .description-single {
			display: flex;
			flex-direction: column;

			row-gap: 0.2rem;
		}
	}

	& .details-container {
		display: flex;
		flex-direction: column;
		row-gap: 1.2rem;

		& .dates-container {
			display: flex;
			column-gap: 2.5rem;

			& > div {
				display: flex;
				flex-direction: column;

				& > span:first-child {
					color: ${theme.color.gray};
					font-size: 0.8rem;
					font-weight: 500;
					text-transform: uppercase;
					font-family: ${theme.font.secondary};
				}

				& > span:last-child {
					display: flex;
					align-items: center;

					column-gap: 0.5rem;

					font-size: 1.2rem;
					font-weight: 500;

					& i {
						display: flex;
					}
				}
			}
		}

		& .unit-container {
			min-height: 4.4rem;
			padding-left: 6.6rem;

			display: flex;
			flex-direction: column;
			justify-content: center;

			position: relative;

			font-size: 1.2rem;
			font-weight: 500;

			& > span {
				color: ${theme.color.gray};
				font-size: 0.8rem;
				font-weight: 500;
				text-transform: uppercase;
				font-family: ${theme.font.secondary};
			}
		}

		& .labels-container {
			display: flex;
			column-gap: 2.5rem;

			& > div {
				display: flex;
				flex-direction: column;

				font-size: 1.2rem;
				font-weight: 500;

				& > span:first-child {
					color: ${theme.color.gray};
					font-size: 0.8rem;
					font-weight: 500;
					text-transform: uppercase;
					font-family: ${theme.font.secondary};
				}

				& > span:last-child {
				}
			}
		}
	}

	& a {
		text-decoration: underline;
	}

	& > a {
		width: min-content;
		margin: 1.5rem auto 0;

		display: block;
		position: absolute;
		bottom: 1.8rem;
		left: 50%;

		font-family: ${theme.font.secondary};
		font-size: 1.2rem;
		font-weight: 500;
		text-transform: uppercase;
		text-decoration: none;
		white-space: nowrap;

		transform: translateX(-50%);
	}
`;
